import { useEffect, useState } from "react";
import Monogram from "./Monogram";
import { useCopy, useLanguage } from "../i18n";

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const { lang, setLang } = useLanguage();
  const copy = useCopy();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled
          ? "border-b border-[rgba(18,19,22,0.08)] bg-[#FBFBF9]/80 backdrop-blur-xl"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-4">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 text-[#1E2A38]">
          <Monogram className="h-9 w-9" />
          <span className="hidden font-serif-display text-xl italic sm:block">Stefano Plaia</span>
        </a>
        <div className="hidden items-center gap-9 lg:flex">
          {copy.nav.links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm text-[#525866] transition-colors duration-300 hover:text-[#B89762]"
            >
              {l.label}
            </a>
          ))}
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center rounded-full border border-[rgba(18,19,22,0.12)] p-0.5">
            {["it", "en"].map((code) => (
              <button
                key={code}
                type="button"
                onClick={() => setLang(code)}
                data-testid={`lang-toggle-${code}`}
                className={`rounded-full px-2.5 py-1 text-xs font-medium uppercase transition-colors duration-300 ${
                  lang === code ? "bg-[#1E2A38] text-[#FBFBF9]" : "text-[#525866] hover:text-[#121316]"
                }`}
              >
                {code}
              </button>
            ))}
          </div>
          <a
            href="#contatti"
            data-testid="nav-cta"
            className="rounded-full bg-[#1E2A38] px-5 py-2.5 text-sm font-medium text-[#FBFBF9] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#121316] sm:px-6"
          >
            {copy.nav.cta}
          </a>
        </div>
      </nav>
    </header>
  );
};

export default Nav;
